/** @format */

import {Typography} from '@mui/material';

import {LabelCard, LabelText, Root} from './styles';
import {Chart} from '../../model/charts';

interface Props<ChartId> {
  chart: Chart<ChartId>;
}

const LabelBox = <ChartId,>({chart}: Props<ChartId>) => {
  const showType = Boolean(chart.labelType);

  return (
    <Root>
      <LabelCard>
        <LabelText color={chart.color} showType={showType}>
          {showType && <Typography component='span'>{chart.labelType}</Typography>}
          {chart.label}
        </LabelText>
      </LabelCard>
    </Root>
  );
};

export {LabelBox};
